function isProductPage(): boolean {
	return document.querySelector(".extendo .exto-container") !== null;
}

export function getMobileCutoff() {
	return 1064;
}

function isCategoryPage(): boolean {
	return document.querySelector(".exto-category-filters") !== null;
}

function isCartPage(): boolean {
	return document.querySelector("#exto-cart") !== null;
}

if (isProductPage()) {
	import("./front/product-page/ProductPage").then((e) => new e.default());
}

if (isCategoryPage()) {
	import("./front/category-page/CategoryPage").then((e) => new e.default());
}

if (isCartPage()) {
	import("./front/cart-page/CartPage").then((e) => new e.default());
}
